export enum TaxRegimeEnum {
    MEI = 1,
    SimplesNacional = 2
}